/** Shopify CDN: Minification failed

Line 280:2 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 280:51 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 316:40 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 346:2 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 399:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 462:13 Transforming let to the configured target environment ("es5") is not supported yet

**/
/* eslint-disable no-undef */
/* eslint-disable strict */
/* eslint-disable newline-per-chained-call */
////////'use strict';

(function AjaxCart() {
  var renderCart = Simba.Functional.compose(
    promiseResolve,
    // getCrossSells,
    updateNavQty,
    appendMarkup,
    setCartTotal,
    initItemEvents,
    initAccountItemEvents,
    initCartEvents,
    collateData
  );

  var publicAPI = {
    open: showCart,
    close: hideCart,
    isOpened: isCartOpen,
    cartAdd: cartAdd,
    fireGTMAddToCartEvents: fireGTMAddToCartEvents,
    cartCall: cartCall,
    cartChange: cartChange,
    cartUpdate: cartUpdate,
    refresh: cartRefresh,
    resetForm: resetForm,
    formSubmit: formSubmit,
    getCart: getCart,
    getUpsellData: getUpsellData,
    upsellFormSubmit: upsellFormSubmit
  };

  var format = Simba.Functional.partial(Simba.Money.format, Simba.Liquid.string('"{{amount}} €"'));
  var formatWithoutTrailingZeros = Simba.Functional.partial(
    Simba.Money.format,
    Simba.Liquid.string('"{{amount_no_decimals}} €"')
  );

  Simba.AjaxCart = publicAPI;

  // ******************************

  window.addEventListener('load', function () {
    if (typeof cartButton !== 'undefined') {
      if (cartButton.classList.contains('open')) {
        cartRefresh(true);
        return;
      }
    }

    /** ----------------------------
     * The code below is used for the mattress recycling service.
     * The cart is retrieved, we loop through and check if the
     * mattress recycling service (product) exists in the cart,
     * if it is present, it is removed because this means the customer
     * has moved away from the checkout page and has navigated back to* the site. SIM-3145
     */
    Simba.AjaxCart.getCart().then((cartContent) => {
      var items = {};
      var quantity = 0;
      cartContent.items.forEach((cartItem) => {
        // Check for existing mattress recycling service(s)
        if (cartItem.id === 43796115718318) {
          cartItem.quantity = quantity;
          items = { id: cartItem.id, quantity: quantity };
          cartCall(window.Simba.Lang.url + `/cart/change.js`, 'POST', items).then(() => {
            cartRefresh(false);
          });
        }
      });
    });

    cartRefresh(false);
  });

  function collateData(cartObj) {
    var $cartMarkup = createMarkup(cartObj);
    var ecoTaxTotal = calculateEcoTaxTotal(cartObj);
    var cartLevelDiscountApplications = createCartLevelDiscountApplications(cartObj);

    cartObj.total_discount += getExtraDiscountFromComparePrices(cartObj);

    return {
      cart: cartObj,
      hasDiscount: cartObj.total_discount !== 0,
      isCartEmpty: cartObj.item_count === 0,
      ecoTaxTotal: ecoTaxTotal,
      cartLevelDiscountApplications: cartLevelDiscountApplications,
      $markup: $cartMarkup,
      $items: cartItems($cartMarkup),
      $accountUpsellItems: accountUpsells(),
      $navQty: $('[data-cart]'),
      $openTrigger: $('[data-cart-open]'),
      $closeTrigger: $('[data-cart-close]'),
      $formSubmitTrigger: $('[data-product-form]'),
      $btnSubmitTrigger: $('[data-atc]'),
      $cartContainer: $('[data-cart-container]'),
      $cartDiscount: $('[data-cart-discount]'),
      $cartDiscountValue: $('[data-cart-discount-value]'),
      $cartLevelDiscountsContainer: $('[data-cart-level-discounts-container]'),
      $cartEcoTaxTotal: $('[data-cart-eco-tax-total]'),
      $cartTotalValue: $('[data-cart-subtotal-value]'),
      $cartState: $('[data-cart-empty]'),
      $quantitySelect: $('[data-quantity-select]'),
      $btnQuantityChange: $('[data-quantity-change]')
    };
  }

  function initCartEvents(data) {
    // Open & close cart
    data.$openTrigger.off('click').on('click', showCart);
    data.$closeTrigger.off('click').on('click', hideCart);

    // Close cart on escape key
    $(document).off('keydown').on('keydown', escapeKeyClose);

    // Add to cart, product form submit
    data.$formSubmitTrigger.off('submit').on('submit', formSubmit);
    // Add to cart, desktop bar button
    data.$btnSubmitTrigger.off('click').on('click', formSubmit);

    // Quantity selector
    data.$btnQuantityChange.off('click').on('click', function () {
      var newVal = parseInt(data.$quantitySelect.val(), 10) + parseInt($(this).data('quantity-change'), 10);
      data.$quantitySelect.val(newVal <= 0 ? 1 : newVal);
    });

    // Simba.gtmAddEventListener('CartInitCheckout');
    Simba.Event.emit('ajaxCartInitialised');

    return data;
  }

  function initItemEvents(data) {
    data.$items.each(function (idx, item) {
      item.$select.on('change', function selectChange() {
        setItemPrice(data);
      });

      item.$qtyBtn.on('click', function qtyClick() {
        setItemQty(item, this);
      });

      item.$qtyInput.on('change', function qtyChange() {
        // Return if the qty input is a cross-sale item
        if (!this.hasAttribute('data-key')) return;

        cartChange({
          quantity: this.value,
          id: this.getAttribute('data-key')
        });
      });

      item.$atc.on('click', function atcClick() {
        itemAtc(item);
      });
    });

    return data;
  }

  function resetForm(form) {
    $(form).off('submit').on('submit', formSubmit);
  }

  function initAccountItemEvents(data) {
    data.$accountUpsellItems.each(function (idx, item) {
      item.$select.on('change', function selectChange() {
        setItemPrice(data);
      });

      item.$qtyBtn.on('click', function qtyClick() {
        setItemQty(item, this);
      });

      item.$qtyInput.on('change', function qtyChange() {
        // Return if the qty input is a cross-sale item
        if (!this.hasAttribute('data-key')) return;
        cartChange({
          quantity: this.value,
          id: this.getAttribute('data-key')
        });
      });

      item.$atc.on('click', function atcClick() {
        itemAtc(item, true);
      });
    });

    return data;
  }

  function setCartTotal(data) {
    var cart = data.cart;

    data.$cartTotalValue.html(formatWithoutTrailingZeros(cart.total_price));
    data.$cartDiscountValue.html(formatWithoutTrailingZeros(cart.total_discount));
    data.$cartState.attr('data-cart-empty', data.isCartEmpty);
    data.hasDiscount ? data.$cartDiscount.removeAttr('hidden') : data.$cartDiscount.attr('hidden', true);
    data.$cartEcoTaxTotal.html(format(data.ecoTaxTotal));
    data.$cartLevelDiscountsContainer.html(data.cartLevelDiscountApplications);

    return data;
  }

  function appendMarkup(data) {
    data.$cartContainer.html(data.$markup);
    return data;
  }

  function updateNavQty(data) {
    var cart = data.cart;
    data.$navQty.attr('data-cart', cart.item_count);
    return data;
  }

  function getAtcData() {
    var obj;
    var $formSubmitTrigger = $('[data-product-form]');
    var selectedId = $formSubmitTrigger.find('[data-variant-select]').val();
    var quantity =
      $formSubmitTrigger.find('[data-quantity-select]').length > 0 ? parseInt($formSubmitTrigger.find('[data-quantity-select]').val(), 10) : 1;
    var $option = $formSubmitTrigger.find(':selected');
    var multiIds = $option.attr('data-multi');
    var lineProperties = getAtcLineProperties();
    var bedBaseId = $('#data-bed-base').attr('data-bed-base-id');
    var freeQuantity = $option.data('free-item') ? parseInt($option.data('free-item'), 10) : 0;

    var ids = multiIds ? multiIds.split(',').concat(selectedId) : [selectedId];
    ids = bedBaseId ? ids.concat(bedBaseId.split(',')) : ids;

    obj = ids.reduce(function (acc, cur) {
      acc[cur] = (acc[cur] || 0) + quantity + freeQuantity;
      return acc;
    }, {});

    return Object.keys(obj).map(function (key) {
      return { id: key, quantity: obj[key], properties: lineProperties };
    });
  }

  /* CRO SIM-3120 */
  function getUpsellData() {
    var obj;
    var $upsellFormFields = $('[data-upsell-form]');
    var selectedId = $upsellFormFields.find('[data-upsell-select]').val();
    var quantity =
      $upsellFormFields.find('[data-quantity-select]').length > 0 ? parseInt($upsellFormFields.find('[data-quantity-select]').val(), 10) : 1;
    var $option = $upsellFormFields.find(':selected');
    var multiIds = $option.attr('data-multi');
    var lineProperties = getAtcLineProperties();
    var freeQuantity = $option.data('free-item') ? parseInt($option.data('free-item'), 10) : 0;

    var ids = multiIds ? multiIds.split(',').concat(selectedId) : [selectedId];

    obj = ids.reduce(function (acc, cur) {
      acc[cur] = (acc[cur] || 0) + quantity + freeQuantity;
      return acc;
    }, {});

    return Object.keys(obj).map(function (key) {
      return { id: key, quantity: obj[key], properties: lineProperties };
    });
  }

  async function upsellFormSubmit(data, showUpsell = true) {
    var cart;
    var $btnAddToCart = $('[data-upsell-accept]');

    cart = cartAdd(getUpsellData(), showUpsell).then(getCart).then(emitCartAdd).then(renderCart).then(showCart);
    cart.always(function () {
      cartUpdate(data, false);
      $btnAddToCart.attr('data-upsell-accept', '');
      $btnAddToCart.attr('disabled', false);
    });

    return true;
  }

  function cartUpdate(data) {
    var dfd = jQuery.Deferred();
    cartCall(window.Simba.Lang.url + '/cart/update.js', 'POST', data)
      .then(emitCartAdd)
      .then(renderCart);
    return dfd.promise();
  }

  /* END CRO SIM-3120 */

  function getAtcLineProperties() {
    var linePropertiesInputs = $.makeArray($('[data-product-line-properties] input'));

    var props = linePropertiesInputs.reduce(function lineProperty(acc, input) {
      var name = input.name.replace('properties[', '').replace(']', '');
      acc[name] = input.value;
      return acc;
    }, {});

    return props;
  }

  function cartAdd(variants, showUpsell = true) {
    var dfd = jQuery.Deferred();
    // Add CRO Test name and group, because cart attributes do not pass to line item scripts wheras line item attributes do
    variants.forEach(function (variant) {
      variant.properties = addCroProperties(variant.properties);
    });

    cartCall(window.Simba.Lang.url + '/cart/add.js', 'POST', { items: variants }).then(function (response) {
      // if (typeof Simba.UpsellDrawer !== 'undefined' && showUpsell) {
      //   Simba.UpsellDrawer.invokeUpsell(response.items, 'mattress');
      // }

      // if (typeof Simba.UpsellDrawer !== 'undefined' && showUpsell && Simba.Upsell.show_accessory_upsell_cro) {
      //   Simba.UpsellDrawer.invokeUpsell(response.items, 'accessory');
      // }
      dfd.resolve();
    });
    return dfd.promise();
  }

  function emitCartAdd(cartData) {
    var dfd = jQuery.Deferred();

    Simba.Cart = $.extend(Simba.Cart, cartData);
    Simba.Event.emit('cart:change', { cart: Simba.Cart });
    dfd.resolve(cartData);

    return dfd.promise();
  }

  async function cartChange(data) {
    cartCall(window.Simba.Lang.url + '/cart/change.js', 'POST', data)
      .then(emitCartAdd)
      .then(renderCart);
  }

  function cartRefresh(show) {
    getCart()
      .then(emitCartAdd)
      .then(renderCart)
      .then(function () {
        if (show) {
          showCart();
        }
      });
    return false;
  }

  function showCart() {
    showCartUI().then(fireGTMCartPageLoadEvent);
    Simba.Event.emit('ajaxCartOpened');

    return false;
  }

  function showCartUI() {
    var dfd = jQuery.Deferred();

    $('html').addClass('cart-open');
    $('body').addClass('ajax-cart-show');

    dfd.resolve();
    return dfd.promise();
  }

  function hideCart() {
    $('html').removeClass('cart-open');
    $('body').removeClass('ajax-cart-show');
    return false;
  }

  function isCartOpen() {
    return $('body').hasClass('ajax-cart-show');
  }

  function escapeKeyClose(evt) {
    if (evt.keyCode === 27 && isCartOpen()) hideCart();
  }

  function formSubmit(evt) {
    var cart;
    var $btnAddToCart = $('[data-atc-submit]');
    var openCart = true;
    const crossSellData = getAtcData();

    if (evt?.currentTarget?.hasAttribute('data-form-open-cart') && evt?.currentTarget?.getAttribute('data-form-open-cart') === 'false') {
      openCart = false;
    }
    $btnAddToCart.attr('data-atc-submit', 'submitting');
    $btnAddToCart.attr('disabled', true);
    cart = cartAdd(getAtcData()).then(fireGTMAddToCartEvents(getAtcData())).then(getCart).then(emitCartAdd).then(renderCart);

    if (openCart !== false) {
      cart.then(showCart);
    }

    cart.always(function () {
      $btnAddToCart.attr('data-atc-submit', '');
      $btnAddToCart.attr('disabled', false);
    });

    cart.then(function () {
      Simba.Event.emit('product-form:add-to-cart', crossSellData);
    });

    return false;
  }

  function getCartConfig() {
    if (!document.querySelector('[data-cart-config]')) return false;
    return JSON.parse(document.querySelector('[data-cart-config]').innerHTML);
  }

  // prettier-ignore
  function createMarkup(cart) {
    /* eslint-disable */
    var cartConfig = getCartConfig();

    // Update Cart Items From Simba Cart (For Multilingual)
    cart.items = Simba.Cart.items;
    var itemTemplate = cart.items.reduce(function (acc, cartItem) {
      // If compare_at prices are in use, use them instead of the normal original price
      var originalPrice = formatWithoutTrailingZeros(cartItem.original_line_price);
      if (Simba.Product[cartItem.variant_id].compareAtPriceRaw > cartItem.original_price) {
        originalPrice = formatWithoutTrailingZeros(Simba.Product[cartItem.variant_id].compareAtPriceRaw * cartItem.quantity);
      }
      var finalPrice = formatWithoutTrailingZeros(cartItem.final_line_price);

      // Check For Cart Product Flash
      var productFlash = '';
      if (typeof cartConfig.promotion_products[cartItem.handle] === 'object') {
        if (typeof cartConfig.promotion_products[cartItem.handle].cart_product_flash === 'string') {
          if (cartItem.total_discount === 0) {
            productFlash = '<div class="relative"><span class="bundle-saving self-center py-5 inline-block mt-5" style="margin-left: 0px;">' + cartConfig.promotion_products[cartItem.handle].cart_product_flash + '</span></div>';
          }
        }
      }

      var itemTitle = (cartItem.variant_title)
        ? '<span class="cart-item__variant-title text-14">' + cartItem.variant_title + '</span>'
        : '';

      if (cartItem.product_type.toLowerCase() === 'bed base') {
        itemTitle = '';

        for (let index = 0; index < cartItem.options_with_values.length; index++) {
          itemTitle += '<span class="cart-item__variant-title text-14">' + cartItem.options_with_values[index].name + ': ' + cartItem.options_with_values[index].value + '</span><br>';
        }
      }

      var itemEadd = (Simba.Product[cartItem.id].eaddFormatted)
        ? '<span class="cart-item__eadd text-blue-accent block text-12">' + 'Date de livraison la plus proche : ' + Simba.Product[cartItem.id].eaddFormatted + '</span>'
        : '';

      var itemPrice = (cartItem.original_line_price !== cartItem.final_line_price) ? '<span class="cart-item__original-price line-through">' + originalPrice + '</span> &nbsp;<span class="cart-item__price text-blue-accent">' + finalPrice + '</span>'
        : (Simba.Product[cartItem.variant_id].compareAtPriceRaw * cartItem.quantity) > cartItem.final_line_price ? '<span class="cart-item__original-price line-through">' + formatWithoutTrailingZeros(Simba.Product[cartItem.variant_id].compareAtPriceRaw * cartItem.quantity) + '</span> &nbsp;<span class="cart-item__price text-blue-accent">' + finalPrice + '</span>'
          : '<span>' + finalPrice + '</span>';

      var itemImg = (cartItem.image === null)
        ? '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
        : cartItem.image.replace(/(\.[^.]*)$/, '_200x$1');

      acc +=
        '<div class="relative flex shadow w-full mb-20 px-10 pt-10 pb-10" data-cart-item data-test="cart-item">' +
        ' <a class="w-1/4" href="' + cartItem.url + '">' +
        '   <picture class="block ratio-1x1">' +
        '     <img class="block max-w-full" alt="' + cartItem.product_title + '" src="' + itemImg + '" />' +
        '   </picture>' +
        ' </a>' +
        ' <div class="w-3/4 pl-10 pt-20">' +
        '   <button type="button" class="absolute right-10" data-cart-qty-modifier="0" aria-label="Retirer">' +
        '     <svg class="block svg-icon" width="20" height="20" style="color: #0c497f">' +
        '       <use xlink:href="#icon-cart-close"></use>' +
        '     </svg>' +
        '   </button>' +
        '   <div class="mb-20">' +
        '     <span class="cart-item__title text-16 font-600 block pr-20">' + cartItem.product_title + '</span>' + itemTitle +
        itemEadd + productFlash +
        '   </div>' +
        '   <div class="relative">' +
        '     <div class="relative max-w-100 float-left">' +
        '       <button type="button" class="abs-vertical left-0" data-cart-qty-modifier="-1" aria-label="Diminuer la quantité">' +
        '         <svg class="cart-item__minus block svg-icon" width="20" height="20" style="color: #0c497f"><use xlink:href="#icon-cart-minus"></use></svg>' +
        '       </button>' +
        '       <label><span class="visually-hidden">Quantité</span>' +
        '         <input type="number" class="input-number-reset border-0 text-center max-w-full h-full bg-transparent" data-cart-qty-input value="' + cartItem.quantity + '" min="0" data-key="' + cartItem.key + '"  />' +
        '       </label>' +
        '       <button type="button" class="abs-vertical right-0" data-cart-qty-modifier="1" aria-label="Augmenter la quantité">' +
        '         <svg class="cart-item__plus block svg-icon" width="20" height="20" style="color: #0c497f"><use xlink:href="#icon-cart-plus"></use></svg>' +
        '       </button>' +
        '     </div>' +
        '     <div class="relative right-10 top-0 text-right max-w-80 s:max-w-full float-right">' + itemPrice + '</div>' +
        '   </div>' +
        ' </div>' +
        '</div>';

      return acc;
    }, '');

    return $('<div>').html(itemTemplate);
    /* eslint-enable */
  }

  function getCrossSells(data) {
    // prettier-ignore
    var crossSellSequence = Simba.Functional.compose(initCrossSellSlick, appendCrossSellMarkup, setItemPrice, initItemEvents, collateCrossSellData);
    getCrossSaleMarkup().then(crossSellSequence);

    function collateCrossSellData($markup) {
      var items = cartItems($markup);
      if (items.length < 1) {
        $('[hidden-cro-ab]').hide();
      } else {
        $('[hidden-cro-ab]').show();
      }

      return {
        $markup: $markup,
        $items: items,
        $container: $('[data-ajax-cart] [data-cross-sell-container]'),
        $sliderContainer: $markup.find('[data-cross-sell-slider]')
      };
    }

    function appendCrossSellMarkup(crossSellData) {
      crossSellData.$container.html(crossSellData.$markup);
      return crossSellData;
    }

    function initCrossSellSlick(crossSellData) {
      // eslint-disable-next-line
      new tns({
        container: crossSellData.$sliderContainer[0],
        loop: true,
        nav: false,
        speed: 400,
        gutter: 20,
        prevButton: '[data-ajax-cart] [data-chevron-left]',
        nextButton: '[data-ajax-cart] [data-chevron-right]',
        mouseDrag: true
      });
    }

    return data;
  }

  function cartItems($markup) {
    var $items = $markup.find('[data-cart-item]');

    return $items.map(function (idx, item) {
      var $item = $(item);

      return {
        $select: $item.find('[data-cart-slider-select]'),
        $originalPrice: $item.find('[data-original-price]'),
        $price: $item.find('[data-price]'),
        $priceWrap: $item.find('[data-has-discount]'),
        $qtyBtn: $item.find('[data-cart-qty-modifier]'),
        $qtyInput: $item.find('[data-cart-qty-input]'),
        $atc: $item.find('[data-cart-item-atc]')
      };
    });
  }

  function accountUpsells() {
    var $items = $('[data-upsell-item]');

    return $items.map(function (idx, item) {
      var $item = $(item);

      return {
        $select: $item.find('[data-cart-slider-select]'),
        $originalPrice: $item.find('[data-compare-price]'),
        $price: $item.find('[data-price]'),
        $priceWrap: $item.find('[data-has-discount]'),
        $qtyBtn: $item.find('[data-cart-qty-modifier]'),
        $qtyInput: $item.find('[data-cart-qty-input]'),
        $atc: $item.find('[data-cart-item-atc]')
      };
    });
  }

  function setItemQty(item, btn) {
    var $qtyInput = item.$qtyInput;

    var qtyModifier = Number(btn.getAttribute('data-cart-qty-modifier'));
    var qtyMin = Number($qtyInput.attr('min'));
    var qtyOld = Number($qtyInput.val());
    var qtyNew = qtyModifier === 0 ? 0 : qtyOld + qtyModifier;
    var optionData = {};
    var qtyChanged = 0;

    $qtyInput.val(clamp(qtyNew, qtyMin, 100)).trigger('change');

    // Return if the qty input is a cross-sale item
    if (!$qtyInput.data('key')) return;

    if (qtyOld > qtyNew) {
      qtyChanged = parseInt(qtyOld - qtyNew, 10);
    } else {
      qtyChanged = parseInt(qtyNew - qtyOld, 10);
    }

    optionData = {
      itemKey: $qtyInput.data('key'),
      quantityOld: qtyOld,
      quantityNew: qtyNew,
      quantityChanged: qtyChanged,
      isRemoveButtonPressed: qtyModifier === 0
    };

    fireGTMCartUpdateCartEvent(optionData);
  }

  function setItemPrice(data) {
    data.$items.each(function (idx, item) {
      var id = item.$select.val();
      var variant = Simba.Product[id];
      var propContainer;
      var price = 0;
      var hasDiscount = false;
      var originalPrice = 0;

      if (variant) {
        originalPrice = variant.originalPriceFormattedWithoutTrailingZeros;
      }

      if (variant) {
        if (variant.hasDiscount && Simba.NCD && Simba.NCD.NewCustomerDiscount) {
          propContainer = item.$atc.parent().find('[data-product-line-properties]');
          if (propContainer) {
            propContainer.append('<input type="hidden" name="properties[NewCustomer]" value="' + Simba.NCD.NewCustomerDiscountExpiry + '" />');
          }
        }
        price = variant.priceFormatted;
        hasDiscount = variant.hasDiscount;
      }

      item.$price.text(price);
      item.$originalPrice.text(originalPrice);
      item.$priceWrap.attr('data-has-discount', hasDiscount);
      hasDiscount ? item.$price.removeAttr('hidden') : item.$price.attr('hidden', true);
    });

    return data;
  }

  function itemAtc(item, show) {
    // Added Properties For NCD / Line Item Scripts
    var props = {};
    var linePropertiesInputs = $.makeArray(item.$atc.parent().find('[data-product-line-properties] input'));

    if (linePropertiesInputs) {
      props = linePropertiesInputs.reduce(function lineProperty(acc, input) {
        var name = input.name.replace('properties[', '').replace(']', '');
        acc[name] = input.value;
        return acc;
      }, {});
    }

    // Add CRO Test name and group, because cart attributes do not pass to line item scripts wheras line item attributes do
    addCroProperties(props);

    if (!show) {
      show = false;
    }

    cartAdd([
      {
        id: item.$select.val(),
        quantity: item.$qtyInput.val(),
        properties: props
      }
    ])
      .then(
        fireGTMAddToCartEvents([
          {
            id: item.$select.val(),
            quantity: item.$qtyInput.val(),
            properties: props
          }
        ])
      )
      .then(getCart)
      .then(emitCartAdd)
      .then(renderCart)
      .then(show ? showCart : null);
  }

  function cartCall(endpoint, method, args) {
    var dfd = jQuery.Deferred();

    $.ajax({
      url: endpoint,
      type: method,
      data: args,
      dataType: 'json'
    }).done(function (data) {
      // We need to handle error cases here!!!
      dfd.resolve(data);
    });

    return dfd.promise();
  }

  // URL Override For Paired Products
  function setURLs(cart) {
    cart.items.forEach(function (item) {
      if (window.Simba.Product[item.id] !== undefined && typeof window.Simba.Product[item.id] === 'object') {
        if (window.Simba.Product[item.id].paired_product.handle && !window.Simba.Product[item.id].paired_product.is_parent) {
          item.url = item.url.replace(item.handle, window.Simba.Product[item.id].paired_product.handle);
          item.url = item.url.replace(item.id, window.Simba.Product[item.id].paired_product.id);
        }
      }
    });

    return cart;
  }

  function getCart() {
    var dfd = jQuery.Deferred();
    cartCall(window.Simba.Lang.url + '/cart.js', 'GET', false).then(function (cart) {
      dfd.resolve(setURLs(cart));
    });

    return dfd.promise();
  }

  function getCrossSaleMarkup() {
    var dfd = jQuery.Deferred();
    var url = window.Simba.Lang.url + '/pages/cross-sells';

    $.get(url).then(function (data) {
      dfd.resolve($(data));
    });

    return dfd.promise();
  }

  function promiseResolve() {
    var dfd = jQuery.Deferred();
    dfd.resolve('cart rendered');

    return dfd.promise();
  }

  function clamp(val, min, max) {
    return val > max ? max : val < min ? min : val;
  }

  function fireGTMAddToCartEvents(variants) {
    var dfd = jQuery.Deferred();

    var variant = variants.shift();

    fireGTMAddToCartEvent(variant).then(function () {
      variants.length ? fireGTMAddToCartEvents(variants) : dfd.resolve();
    });

    dfd.resolve();
    return dfd.promise();
  }

  function fireGTMAddToCartEvent(variant) {
    var dfd = jQuery.Deferred();

    // var eventData = window.Simba.gtmConstructEventData('ProductAddToCart', variant);
    // if (eventData) {
    //   window.Simba.gtmPushEvent(eventData);
    // }

    dfd.resolve();
    return dfd.promise();
  }

  function fireGTMCartPageLoadEvent() {
    var dfd = jQuery.Deferred();
    // var eventData = Simba.gtmConstructEventData('CartPageLoad');
    // if (eventData) {
    //   Simba.gtmPushEvent(eventData);
    // }

    dfd.resolve();
    return dfd.promise();
  }

  function fireGTMCartUpdateCartEvent(optionData) {
    var dfd = jQuery.Deferred();
    var eventData2;

    // var eventData = Simba.gtmConstructEventData('CartUpdateCart', optionData);
    // if (eventData) {
    //   Simba.gtmPushEvent(eventData);
    // }

    // if (optionData.isRemoveButtonPressed) {
    //   eventData2 = Simba.gtmConstructEventData('CartRemoveProduct', optionData);
    // } else if (optionData.quantityOld > optionData.quantityNew) {
    //   eventData2 = Simba.gtmConstructEventData('CartUpdateRemoveProduct', optionData);
    // } else {
    //   eventData2 = Simba.gtmConstructEventData('CartUpdateAddProduct', optionData);
    // }

    // if (eventData2) {
    //   Simba.gtmPushEvent(eventData2);
    // }

    dfd.resolve();
    return dfd.promise();
  }

  function calculateEcoTaxTotal(cart) {
    var ecoTaxTotal = 0;
    cart.items.forEach(function (item) {
      var variant = Simba.Product[item.variant_id];
      ecoTaxTotal += variant.ecoTaxRaw * item.quantity;
    });

    return ecoTaxTotal;
  }

  function createCartLevelDiscountApplications(cart) {
    var template = '';

    cart.cart_level_discount_applications.forEach(function (discount) {
      template +=
        '<div class="flex justify-between mb-20 text-blue-accent">' +
        '  <span>' +
        $('[data-cart-level-discounts-container]').attr('data-cart-level-discount-label') +
        ':</span><span class="uppercase">' +
        discount.title +
        '</span> <span class="align-right">-' +
        formatWithoutTrailingZeros(discount.total_allocated_amount) +
        '</span>' +
        '</div>';
    });

    return template;
  }

  function addCroProperties(props) {
    var htmlElement = document.querySelector('html');
    var liquidTestName = htmlElement.getAttribute('data-cro-test');
    var liquidTestGroup = htmlElement.getAttribute('data-cro-group');

    if (
      typeof liquidTestName !== 'undefined' &&
      liquidTestName !== null &&
      liquidTestName !== '' &&
      typeof liquidTestGroup !== 'undefined' &&
      liquidTestGroup !== null &&
      liquidTestGroup !== ''
    ) {
      if (!props) {
        props = {};
      }

      props.croTest = liquidTestName;
      props.croGroup = liquidTestGroup;
    }

    return props;
  }

  function getExtraDiscountFromComparePrices(cart) {
    // Caculate extra savings from compare prices
    var extraDiscount = 0;
    cart.items.forEach(function (cartItem) {
      var comparePrice;
      var originalPrice;
      if (Simba.Product[cartItem.variant_id].compareAtPriceRaw > cartItem.original_price) {
        originalPrice = cartItem.original_line_price;
        comparePrice = Simba.Product[cartItem.variant_id].compareAtPriceRaw * cartItem.quantity;

        extraDiscount += comparePrice - originalPrice;
      }
    });

    return extraDiscount;
  }
})();

